
import { printHumanFloat, printHumanFloatDashboard } from "@/utils/pretty-print";
import Vue from "vue";
import { BookYearService, ChartService} from "@/services";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { TranslateResult } from "vue-i18n";
import { DashboardRevenueNowCompareData } from "@/utils/dashboard/dashboard-revenue-now-compare-data";

export default Vue.extend({
	data(){
		return {
			currentMonthRevenue: 0.0,
			lastMonthRevenue: 0.0,
			additionalYears: [] as {
				BookYear:number,
				Value:number,
				profitPercentage:number
			}[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		currentMonthName():TranslateResult {
			let month = new Date().getMonth()+1;
			if (month > 12){
				month = 1;
			}
			return this.$ct(`common.months.${month}`);
		},
		previousMonthName():TranslateResult {
			let month = new Date().getMonth();
			if (month < 1){
				month = 12;
			}
			return this.$ct(`common.months.${month}`);
		},
		profitPercentage():number {
			return this.getProfitPercentage(this.lastMonthRevenue, this.currentMonthRevenue);
		},
		profitPercentageString():string {
			return this.getPercentageString(this.profitPercentage);
		},
		chartData():DashboardRevenueNowCompareData{
			return this.item.Data as DashboardRevenueNowCompareData;
		},
		colWidth():number{
			if (this.item.width == 1) {
				return 12;
			}
			return 6;
		}
	},
	methods: {
		printHumanFloat(n:number):string{
			return printHumanFloatDashboard(n);
		},
		getProfitPercentage(past:number, current:number):number {
			if (past ==0 && current >0) return 100;
			if (past ==0) return 0;
			if (current == 0) return -100;
			return ((current - past) / past) * 100.0;
		},
		getPercentageString(value:number):string {
			if (value > 0){
				return "+" + printHumanFloat(value, 0);
			}
			return printHumanFloat(value, 0);
		},
		async fetch(){
			let date = new Date();
			let year = BookYearService.getBookYearFromDate(date);
			let bookyear = this.chartData.getBookYearOverrideValue();
			if (!bookyear){
				bookyear = BookYearService.selectedBookYear;
			}
			let yearDiff = year - bookyear;
			date.setFullYear(date.getFullYear()-yearDiff);
			let result = await ChartService.getRevenueOfMonthCompare(date, this.chartData.filters, this.chartData.toShowAdditionalBookYears, bookyear);
			this.currentMonthRevenue = result.ThisMonth;
			this.lastMonthRevenue = result.LastMonth;
			let pastYears = (result.PastYears || []).sort((a,b)=>a.BookYear - b.BookYear);
			this.additionalYears = pastYears.map((year, i)=>{
				let profitPercentage = 0.0;
				if (i != 0) {
					profitPercentage = this.getProfitPercentage(pastYears[i-1].Value, year.Value);
				}
				return {
					...year,
					profitPercentage
				};
			});
		},
	},
	mounted(){
		this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
